package xim.poc.game.configuration.v0.tactics

import xim.math.Vector3f
import xim.poc.ActorManager
import xim.poc.ModelLook
import xim.poc.NoOpActorController
import xim.poc.game.ActorPromise
import xim.poc.game.ActorType
import xim.poc.game.GameEngine
import xim.poc.game.configuration.NoActionBehaviorId
import xim.poc.game.configuration.v0.FloorEntity
import xim.poc.game.event.InitialActorState
import xim.poc.gl.ByteColor
import xim.util.PI_f

class TacticsPortraitDummy: FloorEntity {

    private val location = Vector3f(x=280f,y=24f,z=286f)

    val promise = spawn()

    private var showing = false

    override fun update(elapsedFrames: Float) {
        val color = if (showing) { ByteColor.half } else { ByteColor.zero }
        ActorManager[promise.getIfReady()]?.renderState?.effectColor = color
    }

    override fun cleanup() {
        promise.onReady { GameEngine.submitDeleteActor(it.id) }
    }

    fun show(position: Vector3f) {
        promise.resolveIfReady()?.position?.copyFrom(position)
        showing = true
    }

    fun reset() {
        showing = false
        val state = promise.resolveIfReady() ?: return
        state.position.copyFrom(location)
        state.setBaseLook(ModelLook.npc(0x1F))
    }

    private fun spawn(): ActorPromise {
        return GameEngine.submitCreateActorState(
            InitialActorState(
                name = "(Portrait Dummy)",
                type = ActorType.Effect,
                position = location,
                rotation = PI_f/2,
                modelLook = ModelLook.npc(0x1F),
                movementController = NoOpActorController(),
                behaviorController = NoActionBehaviorId,
                targetable = false
            )
        ).onReady { it.viewCullable = false }
    }

}